/**
 * @file: withUserProfile.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import type { AuthState } from '@euler/app/flows/auth/context';
import { UserProfile } from '@euler/model';
import deepEqual from 'deep-equal';
import produce from 'immer';

/**
 * The auth state with a freshly fetched profile's parts, each replaced only
 * when it changed so subscribers keyed on it do not re-run.
 */
export function withUserProfile(
  state: AuthState,
  profile: UserProfile,
): AuthState {
  return produce(state, draft => {
    if (!draft.isAuthenticated || !state.isAuthenticated) return;
    const current = state.authenticatedUserInfo;
    const next = draft.authenticatedUserInfo;
    if (!deepEqual(current.user, profile.user)) next.user = profile.user;
    if (!deepEqual(current.org, profile.org)) next.org = profile.org;
    if (!deepEqual(current.store, profile.store)) next.store = profile.store;
    if (!deepEqual(current.agent, profile.agent)) next.agent = profile.agent;
    if (!deepEqual(current.entitlements, profile.entitlements)) {
      next.entitlements = profile.entitlements;
    }
  });
}
